import { deforestationDeterLastType } from 'store/typesActions/types';

const initialState = {
	data: [],
	isLoading: false,
	error: false,
	message: ''
};

export default function deforestationDeterLastReducer(state = initialState, action) {
	const { errors } = action?.payload || { erros: {} };

	switch (action.type) {
		case deforestationDeterLastType.DEFORESTATION_DETER_LAST:
			return {
				...state,
				isLoading: true,
				error: false,
				message: 'Buscando dados do desmatamento'
			};

		case deforestationDeterLastType.DEFORESTATION_DETER_LAST_SUCCESS:
			return {
				...state,
				data: action.payload,
				isLoading: false,
				error: false,
				message: ''
			};

		case deforestationDeterLastType.DEFORESTATION_DETER_LAST_ERROR:
			return {
				...state,
				data: [],
				isReq: false,
				error: true,
				message: 'Erro ao buscar por dados, tente novamente mais tarde'
			};
		default:
			return state;
	}
}
